import {
  CUSTOM_ELEMENTS_SCHEMA,
  NO_ERRORS_SCHEMA,
  NgModule,
} from '@angular/core';

import {
  DatepickerModule,
  InputModule,
  ModalModule,
  TooltipModule,
  ButtonModule,
  SelectModule,
  ChipModule,
  CheckboxModule,
  RadiobuttonModule,
  SwitchModule,
  NotificationModule,
  TableModule,
  StepperModule,
  FileModule,
  AutocompleteModule,
  PhoneModule
} from '@avla/ui-design';

const storybookModules = [
  InputModule,
  DatepickerModule,
  TooltipModule,
  ModalModule,
  SelectModule,
  ChipModule,
  ButtonModule,
  CheckboxModule,
  RadiobuttonModule,
  SwitchModule,
  NotificationModule,
  TableModule,
  StepperModule,
  FileModule,
  AutocompleteModule,
  PhoneModule
];

@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
  imports: storybookModules,
  exports: storybookModules,
})
export class StorybookModule {}
